import { NgModule } from "@angular/core";
import { MdBluetoothManager as MdBluetoothManagerComponent } from "./md-bluetooth-manager/md-bluetooth-manager.component";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { BluetoothPrinterService } from "./bluetooth-printer.service";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";

@NgModule({
    declarations: [MdBluetoothManagerComponent],
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        TablerIconsModule
    ],
    providers: [
        BluetoothPrinterService
    ]
})
export class BluetoothPrinterModule {

}